import gql from 'graphql-tag';

const GET_CATEGORIES_HALL = gql`
    query getCategories ($action: String!, $params: CategoriesParams) {
        getCategories (action: $action, params: $params) {
        message,
        status,
        data {
            id,
            name,
            salesChannel,
            childrens {
            id,
            name,
            sector,
            hall
            }
        }
        }
    }
`;

export default GET_CATEGORIES_HALL;
